module.exports = __webpack_public_path__ + "img/builder-20.2576d386.jpg";